<template>
<div class="backup-item">
  <div class="backup-item__info">
    <h3>{{ backup.name }}</h3>
    <p>{{ backup.note }}</p>
  </div>
  <div class="backup-item__data">
    <p class="backup-item__data--date">{{ backup.date }}</p>
    <p class="backup-item__data--weight">{{ backup.weight }} MB <a href="#">Download</a></p>
  </div>
  <div class="backup-item__buttons">
    <el-button plain>Stop</el-button>
    <el-button plain>Clear</el-button>
  </div>
  <el-menu class="backup-item__dropdown" mode="horizontal">
    <el-submenu index="0" popper-class="backup-item__dropdown--items">
      <template slot="title">
        <i class="el-icon-more"></i>
      </template>
      <el-menu-item index="1">Download</el-menu-item>
      <el-menu-item index="2">Duplicate</el-menu-item>
      <el-menu-item index="3">Empty</el-menu-item>
      <el-menu-item index="4">Clear</el-menu-item>
    </el-submenu>
  </el-menu>
</div>
</template>
<script>
export default {
  props: ['backup'],
  data: () => ({}),
};
</script>
<style lang="scss">
.backup-item {
  margin-bottom: 0;
  padding: 25px;
  transition: background-color .3s ease;
  display: flex;
  justify-content: stretch;
  align-items: flex-start;

  &:hover {
    background-color: #FFFFFF;
  }

  div {
    flex: 1;
    text-align: left;
  }

  &__info {
    h3, p {
      margin-top: 0;
      margin-bottom: 5px;
    }

    h3 {
      font-size: 20px;
    }

    p {
      font-size: 16px;
      font-weight: 300;
    }

    &--addresses {
      margin-top: 10px;
      list-style: none;
      font-size: 14px;
    }
  }

  &__data {
    font-size: 16px;

    p {
      margin-top: 0;
      margin-bottom: 10px;
    }

    &--date {
      font-weight: 700;
    }

    &--weight a {
      font-weight: 700;
      color: #409EFF;
      text-decoration: none;
      padding-left: 10px;

      &:hover {
        text-decoration: underline;
      }
    }
  }

  &__buttons {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .el-button {
      padding: 6px 16px;
      margin: 0;
      width: 150px;

      &+.el-button {
        margin-top: 5px;
      }
    }
  }

  &__dropdown {
    position: absolute;
    top: 0;
    right: 0;
    border: none;
    background-color: transparent;

    &--items {
      width: 150px;
    }

    .el-submenu {
      &.is-opened {
        position: relative;
        z-index: 20;
      }

      &__icon-arrow {
        display: none;
      }

      .el-icon-more {
        position: absolute;
        right: 20px;
        top: 26px;
      }

      &__title,
      &__title:hover {
        background-color: transparent !important;
      }
    }

    .is-opened {
      z-index: 10;
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/components/BackupItem.vue